import React from "react";
import Select from "react-select";
import { RightCollapseIcon } from "../../../Static/icons/iconshere";
import SwitchButton from "../../SwitchButton";

const boolOptionsList = [
  {
    value: true,
    label: "True",
  },
  {
    value: false,
    label: "False",
  },
];

const getBooleanValue = (value, list) => list.find((item) => item.value === value);
function camelToTitleCase(camelStr) {
  if (!camelStr) return "";

  const words = camelStr
    .replace(/([A-Z])/g, " $1") // Add space before capital letters
    .replace(/^./, (str) => str.toUpperCase()); // Capitalize first letter

  return words.trim();
}

const KeyValueInput = ({
  showAddButton = true,
  showRemoveButton = false,
  showObjectTitle = true,
  optionList = [],
  inputData,
  onChangeHandler,
  onAddClick,
  onRemoveClick,
  index,
  heading = "",
  errorData = {},
  categoryMapping = {},
}) => {
  return (
    <tr onClick={(e) => e.stopPropagation()}>
      <td>
        <div className="form-group">
          {/* <label>
            Select Object <span> * </span>
          </label> */}
          <Select
            name="Object"
            className="basic-multi-select"
            classNamePrefix="select"
            placeholder="Select Object"
            createNewCustomTags
            options={optionList}
            onChange={(value) => onChangeHandler(inputData.id, "key", value)}
            value={inputData.key}
          />
          {errorData?.key && <p className="error">Please select an option</p>}
        </div>
      </td>
      <td>
        <>
          {/* {categoryMapping[inputData?.key?.value]?.expectedAnimationState && ( */}
          <>
            <div className="form-group justify-content-center">
              {/* <label>
                Animation State <span> * </span>
              </label> */}
              <span className="for-percentage scenario">
                <input
                  name="min_score_to_pass"
                  placeholder="0 - 100"
                  type="number"
                  className="input"
                  value={inputData.value?.expectedAnimationState}
                  onChange={(e) =>
                    onChangeHandler(inputData.id, "value", e.target.value, "percent", "expectedAnimationState")
                  }
                  min={0}
                  max={100}
                />
              </span>
            </div>
          </>
          {/* )} */}
          {/* {categoryMapping[inputData?.key?.value]?.animationFloatValue && ( */}
          <></>
          {/* )} */}
        </>
      </td>

      <td>
        <div className="form-group justify-content-center">
          {/* <label>
            Animation Float Value <span> * </span>
          </label> */}
          <span className="for-percentage scenario">
            <input
              name="min_score_to_pass"
              placeholder="0 - 100"
              type="number"
              className="input"
              value={inputData.value?.animationFloatValue}
              onChange={(e) => onChangeHandler(inputData.id, "value", e.target.value, "float", "animationFloatValue")}
              min={0}
              max={100}
            />
          </span>
        </div>
      </td>
      <td>
        <div className="form-group justify-content-center">
          {/* <label>
            Is Highlight <span> * </span>
          </label> */}
          <>
            {/* <Select
              name="value"
              className="basic-multi-select mt-2"
              classNamePrefix="select"
              placeholder="Select an option"
              createNewCustomTags
              options={boolOptionsList}
              onChange={(e) => onChangeHandler(inputData.id, "value", e.value, "boolean", "isHighlight")}
              value={getBooleanValue(inputData?.value?.isHighlight, boolOptionsList)}
            /> */}

            <SwitchButton
              checked={inputData?.value?.isHighlight === true}
              onChange={(e) => onChangeHandler(inputData.id, "value", e.target.checked, "boolean", "isHighlight")}
            />

            {/* <p className="error">Value can't be empty and it should be between 0 to 100</p> */}
          </>
        </div>
      </td>
      <td>
        <div className="action-btns">
          {showAddButton && (
            <button className="add" onClick={onAddClick}>
              Add
            </button>
          )}
          {showRemoveButton && (
            <button className="remove" onClick={onRemoveClick}>
              Remove
            </button>
          )}
        </div>
      </td>
    </tr>
  );
};

export default KeyValueInput;

{
  /* {(categoryMapping[inputData?.key?.value] === "float" ||
            categoryMapping[inputData?.key?.value] === "percent" ||
            !inputData?.key) && (
            <>
              <span className="for-percentage scenario mt-2">
                <input
                  name="min_score_to_pass"
                  placeholder="0 - 100"
                  type="number"
                  className="input"
                  value={inputData.value}
                  onChange={(e) =>
                    onChangeHandler(inputData.id, "value", e.target.value, categoryMapping[inputData?.key?.value])
                  }
                  min={0}
                  max={100}
                />
                {categoryMapping[inputData?.key?.value] === "percent" && <span className="percentage-view">%</span>}
              </span>
            </>
           )}
          {categoryMapping[inputData?.key?.value] === "boolean" && (
            <Select
              name="value"
              className="basic-multi-select mt-2"
              classNamePrefix="select"
              placeholder="Select an option"
              createNewCustomTags
              options={boolOptionsList}
              onChange={(e) => onChangeHandler(inputData.id, "value", e.value)}
              value={getBooleanValue(inputData?.key, boolOptionsList)}
            />
          )}
          {errorData?.value && categoryMapping[inputData?.key?.value] === "percent" && (
            <p className="error">Value can't be empty and it should be between 0 to 100</p>
          )}
          {errorData?.value &&
            (categoryMapping[inputData?.key?.value] ? categoryMapping[inputData?.key?.value] === "float" : true) && (
              <p className="error">Value can't be empty</p>
            )}
          {errorData?.value && categoryMapping[inputData?.key?.value] === "boolean" && (
            <p className="error">Please select an option</p>
          )} */
}
